import React from 'react';

const Leaderboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-[#1A1F2C] to-black/90 pt-40">
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">Leaderboard</h1>
        <p>Leaderboard content coming soon...</p>
      </div>
    </div>
  );
};

export default Leaderboard;